import { FaFacebook, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { ReactComponent as Logo } from '../assets/logo2.svg';
import { useNavigate } from "react-router-dom";

const Footer = () => {
    const navigate = useNavigate();

    const redes = [
      {name:"", icon:FaWhatsapp, url:"https://api.whatsapp.com/send/?phone=522211001481&text&type=phone_number&app_absent=0"},
      {name:"", icon:FaInstagram, url:"https://www.instagram.com/estrategias.corp0805/"},
      {name:"", icon:FaFacebook, url:"https://www.facebook.com/profile.php?id=100069072834339#"},
    ];
    
    return(
        <footer className="h-fit w-full grid grid-cols-1 p-4 bg-estra shadow text-white">
          <div className="grid grid-cols-4">
            <div className="flex flex-col justify-center gap-8 py-8">
                <Logo className="w-auto h-32" onClick={()=>navigate("/")}/>
            </div>
            <div className="grid place-items-left gap-2">
              <h2 className="text-2xl font-bold"> CONTACTO </h2>
              <p> Tel. 22-11-00-14-81 </p>
              <p> estrategias.corp0805@gmail.com</p>
            </div>
            <div className="grid place-items-left gap-2">
              <h2 className="text-2xl font-bold"> VISITANOS </h2>
              <p> 3 B Sur 3705 -1 Col. Gabriel Pastor, Puebla, Puebla C.P 72420</p>
            </div>
            <div className="grid place-items-left gap-2">
              <h2 className="text-2xl font-bold">HORARIO DE OFICINA</h2>
              <p>Lun - Vie 10:00 am - 7:00 pm</p>
              <p>sÁb -dom Cerrado</p>
            </div>
          </div>
          <div className="w-full flex flex-row justify-around gap-8 py-8">
            <div className="w-fit flex flex-row gap-6">
            {redes.map((red, index) => {
                const Icon = red.icon;
                return (
                    <a
                    key={index}
                    href={red.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={red.name}
                    className="text-white text-2xl hover:text-yellow-300 transition-colors"
                    >
                    <Icon />
                    </a>
                );
                })}
                </div>
                <p className="text-xs"> © 2025 Todos los derechos reservados | Estrategias Corpotativas de Alto Nivel</p>
            </div>
        </footer>
      )
    };

export default Footer;
